/**
 * Debug utility to help troubleshoot authentication and user data loading issues
 */

import { getUserProfile, getUserExamPreferences } from '../firebase/collections';

export const debugUserData = async (userId) => {
  if (!userId) {
    console.log('❌ No user ID provided');
    return;
  }

  console.log('🔍 Debugging user data for:', userId);
  
  try {
    // Check user profile
    const profileResult = await getUserProfile(userId);
    console.log('👤 User Profile:', {
      success: profileResult.success,
      hasData: !!profileResult.data,
      preferences: profileResult.data?.preferences,
      selectedExams: profileResult.data?.preferences?.selectedExams?.length || 0
    });

    // Check exam preferences
    const examPrefsResult = await getUserExamPreferences(userId);
    console.log('📚 Exam Preferences:', {
      success: examPrefsResult.success,
      hasData: !!examPrefsResult.data,
      selectedExams: examPrefsResult.data?.selectedExams?.length || 0,
      activeExam: examPrefsResult.data?.activeExam?.id || 'none'
    });

    // Check localStorage
    const localExams = localStorage.getItem('selectedExams');
    const localActiveExam = localStorage.getItem('activeExam');
    console.log('💾 LocalStorage:', {
      hasExams: !!localExams,
      examsCount: localExams ? JSON.parse(localExams).length : 0,
      hasActiveExam: !!localActiveExam,
      activeExam: localActiveExam ? JSON.parse(localActiveExam).id : 'none'
    });

    return {
      profile: profileResult,
      examPrefs: examPrefsResult,
      localStorage: {
        exams: localExams ? JSON.parse(localExams) : [],
        activeExam: localActiveExam ? JSON.parse(localActiveExam) : null
      }
    };
  } catch (error) {
    console.error('❌ Error debugging user data:', error);
    return null;
  }
};

export const debugAuthMethod = (user) => {
  if (!user) {
    console.log('❌ No user provided');
    return;
  }

  console.log('🔐 Authentication Method Debug:', {
    uid: user.uid,
    email: user.email,
    displayName: user.displayName,
    providerData: user.providerData.map(p => ({
      providerId: p.providerId,
      uid: p.uid,
      email: p.email
    })),
    isEmailAuth: user.providerData.some(p => p.providerId === 'password'),
    isGoogleAuth: user.providerData.some(p => p.providerId === 'google.com'),
    creationTime: user.metadata.creationTime,
    lastSignInTime: user.metadata.lastSignInTime
  });
};

// Add to window for easy debugging in console
if (typeof window !== 'undefined') {
  window.debugUserData = debugUserData;
  window.debugAuthMethod = debugAuthMethod;
}